"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HERO_CHR_ID = void 0;
// 가상의 주인공 캐릭터를 DOChr 처럼 처리하기 위하여 -1 을 사용한다.
// 참고로 -1 보다 작은 음수는 새롭게 추가된 (아직 서버에 저장되지 않은) 캐릭터들이다.
exports.HERO_CHR_ID = -1;
